module.exports = __webpack_public_path__ + "img/engravingRingsize-2.38977ca.webp";